import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class CategoryEndpoints {
  constructor(private http: HttpClient) {}
}
